/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3HCircleIcon16Solid = forwardRef('UiMenuDots3HCircleIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm3.75-5.875a1.126 1.126 0 1 0 0-2.252 1.126 1.126 0 0 0 0 2.252ZM9.127 8a1.127 1.127 0 1 1-2.254 0 1.127 1.127 0 0 1 2.254 0ZM4.25 9.126a1.126 1.126 0 1 0 0-2.253 1.126 1.126 0 0 0 0 2.253Z" })));
});
